import {
  base_colorAction,
  base_colorAlert,
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  base_contentSelected,
  tag_colorTagSevereBackground,
  tag_colorTagSevereText,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { transition_fast } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.WideDropzone {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing(2)};
    padding: ${spacing(6)} ${spacing(4)};
    border: 1px dashed ${base_colorContentBorder};
    background-color: ${base_colorSurfaceSecondary};
    border-radius: ${cornerRadius};
    cursor: pointer;
    transition:
      background-color ${transition_fast} ease-out,
      border-color ${transition_fast} ease-out;
    font-family: ${font_family_weight_regular};

    &:hover {
      border-color: ${base_colorAction};
      background-color: ${base_contentSelected};
    }

    .dropzone-input:focus {
      outline: none;
    }

    .primary {
      ${font_md};
      color: ${text_colorTextPrimary};
    }

    .primary .link {
      color: ${base_colorAction};
      text-decoration: underline;
      cursor: pointer;
    }

    .secondary {
      ${font_sm};
      color: ${text_colorTextSecondary};
    }

    .missing-label {
      ${font_sm};
      font-family: ${font_family_weight_medium};
      color: ${tag_colorTagSevereText};
    }

    &.isMissing {
      border: 1px solid ${base_colorAlert};
      border-radius: ${spacing(1)};
      background-color: ${tag_colorTagSevereBackground + '80'};

      &:hover {
        border-color: ${base_colorAlert};
        background-color: ${tag_colorTagSevereBackground};
      }

      svg path {
        fill: ${base_colorAlert};
      }
    }

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    &.isInline {
      width: auto;
      align-self: flex-start;
      flex-direction: row;
      justify-content: flex-start;
      gap: ${spacing(1)};
      padding: 0;
      border: 0;
      border-radius: ${cornerRadius};
      background-color: transparent;
      color: ${base_colorAction};
      ${font_md};
      cursor: default;

      .WideDropzone--inline-button {
        display: inline-flex;
        align-items: center;
        gap: ${spacing(1)};
        padding: 0;
        border: 0;
        border-radius: ${cornerRadius};
        background: transparent;
        color: inherit;
        cursor: pointer;
        font-family: ${font_family_weight_medium};
        ${font_md};

        &:hover {
          text-decoration: underline;
        }

        &:focus-visible {
          outline: 2px solid ${base_colorAction};
          outline-offset: ${spacing(1)};
        }
      }

      .add-receipt-icon {
        width: ${spacing(4)};
        height: ${spacing(4)};
        display: block;
      }
    }
  }
`
